export enum OrderErrorReason {
  IdSignatureEncryptionFailed = 'IdSignatureEncryptionFailed',
}
